import { LegacyPortalDashboardService } from "@spwn-portal/grpc";
import firebase from "firebase/app";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useSWR from "swr";

import { useConnectClient } from "../../utility/connectWeb";

export type IssueTicketSummary = {
  ticketId: string;
  name: string;
  purchasedCount: number;
  checkedInCount: number;
  checkedInRate: number;
  redeemableCount: number;
  redeemedCount: number;
  redeemedRate: number;
};

//エラーの型
export type FetchAdminTicketError = {
  message: string;
};

const FetchAdminTicketKey = "fetchAdminTicket";
const REFRESH_INTERVAL_MS = 30 * 1000; // 30秒

export const useFetchAdminTicket = () => {
  //チケットidをクエリから取得する
  const { search } = useLocation();
  const ticketIds = useMemo(() => {
    const params = new URLSearchParams(search);
    const ticketIds = params.getAll("ticket_id");
    return ticketIds;
  }, [search]);

  const auth = firebase.auth();
  const connectClient = useConnectClient(LegacyPortalDashboardService);
  const currentUserId = auth.currentUser?.uid ?? null;
  const {
    data: issuedTicketSummary,
    isLoading,
    error,
  } = useSWR<IssueTicketSummary[], FetchAdminTicketError>(
    currentUserId && ticketIds.length > 0
      ? [FetchAdminTicketKey, currentUserId, ticketIds]
      : null,
    async () => {
      const response = await connectClient.getAllIssuedTicketSummary({
        ticketIds,
      });

      return (response.tickets ?? []).map((ticket) => ({
        ticketId: ticket.ticketId,
        name: ticket.ticketName,
        purchasedCount: ticket.purchasedCount,
        checkedInCount: ticket.checkedInCount,
        checkedInRate: ticket.checkedInRate,
        redeemableCount: ticket.redeemableCount,
        redeemedCount: ticket.redeemedCount,
        redeemedRate: ticket.redeemedRate,
      }));
    },
    {
      refreshInterval: REFRESH_INTERVAL_MS,
    }
  );
  return useMemo(() => {
    const displayTicketSummary = issuedTicketSummary ?? [];
    return {
      displayTicketSummary,
      isLoading,
      error,
    };
  }, [issuedTicketSummary, isLoading, error]);
};
